
<template>
  <div>
    <v-row>
      <v-col class="min-width-7" cols="7">
        <!-- Proble Type -->
        <v-row>
          <v-col cols="4" class="pb-0 col-lable">
            <label class="font-weight-bold">
              {{ $t("PROBLEM_TYPE") }}
              <span class="red--text">*</span>
            </label>
          </v-col>
          <v-col class="pb-0 px-0">
            <v-select
              dense
              :items="probleType"
              v-model="isValue"
              @change="setTypeValue"
              item-text="text"
              item-value="key"
              item
              outlined
              style="max-width: 270px"
              class="mr-10"
            />
          </v-col>
        </v-row>

        <component :is="`Form${isValue}`" ref="form" :parent="parent" />
      </v-col>
      <v-col class="min-width-4 max-width-4 ml-10 p-0 pb-2" cols="4">
        <div class="template-show pa-3">
          <component :is="`Template${isValue}`" :no="this.$route.query.no" />
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-btn color="primary" class="ml-10" @click="checkValidate">{{
        $t("REGISTER")
      }}</v-btn>
      <Dialog v-model="dialogConfirmCreate" :title="$t('COMFIRMATION')">
        <template v-slot:content>登録します。よろしいですか。</template>
        <template v-slot:actions>
          <v-btn color @click="dialogConfirmCreate = false" small>{{
            $t("CANCEL")
          }}</v-btn>
          <v-btn
            :disabled="loaddingAddGeneral"
            color="primary"
            small
            :loading="loaddingAddGeneral"
            @click="handleCreateQuestion"
            >{{ $t("OK") }}</v-btn
          >
        </template>
      </Dialog>

      <v-btn color class="ml-10" @click="$router.go(-1)">{{
        $t("BACK")
      }}</v-btn>
    </v-row>
  </div>
</template>

<script>
import { createQuestion } from "@/api/Question.api";
import uploadFile from "@/utils/uploadFile";
import mixin from "@/mixin";
import { FormBuilder } from "@/views/listGeneral/formbuilder.js";
export default {
  components: FormBuilder.$options.components,
  store: ["formGeneral"],
  mixins: [mixin.ValidateGeneral],
  data() {
    return {
      probleType: [
        { text: "語彙・文法：4択", type: "write", key: "Choices" },
        { text: "語彙・文法：並び替え", type: "write", key: "Sort" },
        { text: "語彙・文法：ダイヤル入力", type: "write", key: "Conjugation" },
        { text: "漢字読み", type: "write", key: "Kanji" },
        { text: "短文聴解", type: "listen", key: "ShortSentences" },
        { text: "長文聴解", type: "listen", key: "LongSentences" },
      ],
      dialogConfirmCreate: false,
      isType: "write",
      isValue: "Choices",
      loaddingAddGeneral: false,
    };
  },
  watch: {
    isValue: function (val) {
      if (val == "MultiRead") {
        this.formGeneral.isAnsewr = [1];
      }
    },
  },
  created() {
    if (this.$route.name !== "Create General OF Section") {
      this.probleType.push(
        { text: "読解：4択", type: "read", key: "Comprehension" },
        { text: "読解：複数選択", type: "read", key: "MultiRead" }
      );
    }
  },
  computed: {
    parent() {
      var parent = "";
      if (
        this.$route.name == "Create General OF Season" ||
        this.$route.name == "Update General OF Season"
      ) {
        parent = "season";
      } else if (
        this.$route.name == "Create General OF Chapter" ||
        this.$route.name == "Update General OF Chapter"
      ) {
        parent = "chapter";
      } else if (
        this.$route.name == "Create General OF Section" ||
        this.$route.name == "Update General OF Section"
      ) {
        parent = "section";
      }
      return parent;
    },
  },
  methods: {
    async handleCreateQuestion() {
      this.loaddingAddGeneral = true;
      let params = await this.$refs.form.getParams();
      if (params) {
        params.type_value = this.isValue;
        params = await this.checkFile(params);
        await createQuestion(params)
          .then(async () => {
            this.dialogConfirmCreate = false;
            this.back();
          })
          .catch((error) => {
            const { parent } = this;
            if (error.response.data.result.error == "CREATE_ERROR") {
              if (parent == "season") {
                this.$toast.error("既に50まとめが存在ます。登録できない。");
              }
              if (parent == "chapter") {
                this.$toast.error("既に30まとめが存在ます。登録できない。");
              }
              if (parent == "section") {
                this.$toast.error("既に10まとめが存在ます。登録できない。");
              }
            }
          });
        this.loaddingAddGeneral = false;
      } else {
        this.loaddingAddGeneral = false;
        this.dialogConfirmCreate = false;
      }
    },
    async checkValidate() {
      let params = await this.$refs.form.getParams();
      if (params) {
        this.dialogConfirmCreate = true;
      }
    },
    async checkFile(params) {
      if (params.audio && params.audio.file) {
        await uploadFile(params.audio.file, "audio").then((e) => {
          params.audio = e;
        });
      }
      if (params.image && params.image.file) {
        await uploadFile(params.image.file, "image").then((e) => {
          params.image = e;
        });
      }
      if (
        params.sub_question.question1.audio &&
        params.sub_question.question1.audio.file
      ) {
        await uploadFile(
          params.sub_question.question1.audio.file,
          "audio"
        ).then((e) => {
          params.sub_question.question1.audio = e;
        });
      }
      if (
        params.sub_question.question2.audio &&
        params.sub_question.question2.audio.file
      ) {
        console.log("question2: ", params.sub_question.question2);
        await uploadFile(
          params.sub_question.question2.audio.file,
          "audio"
        ).then((e) => {
          params.sub_question.question2.audio = e;
        });
      }
      return params;
    },
    setTypeValue(value) {
      this.isType = this.probleType.find((e) => e.key == value).type;
      this.isValue = value;
      this.setDefault();
    },
    back() {
      const { query } = this.$route;
      delete query.no;
      if (this.parent == "season") {
        this.$router.push({
          name: "List General OF Season",
          params: { season: this.$route.params.season },
          query,
        });
      }
      if (this.parent == "chapter") {
        this.$router.push({
          name: "List General OF Chapter",
          params: { season: this.$route.params.chapter },
          query,
        });
      }
      if (this.parent == "section") {
        this.$router.push({
          name: "List General OF Section",
          params: { season: this.$route.params.section },
          query,
        });
      }
    },
    setDefault() {
      this.formGeneral = {
        leadSentence: "",
        name: [["", ""]],
        name1: "",
        name2: "",
        isAnsewr: 1,
        verb: "",
        kanji: "",
        audio: null,
        image: null,
        script: "",
        sub_question: {
          question1: {
            answers: [
              {
                id: 1,
                name: "回答1",
                value: "",
              },
              {
                id: 2,
                name: "回答2",
                value: "",
              },
              {
                id: 3,
                name: "回答3",
                value: "",
              },
              {
                id: 4,
                name: "回答4",
                value: "",
              },
            ],
            script: "",
            audio: null,
            isAnsewr: 1,
          },
          question2: {
            answers: [
              {
                id: 1,
                name: "回答1",
                value: "",
              },
              {
                id: 2,
                name: "回答2",
                value: "",
              },
              {
                id: 3,
                name: "回答3",
                value: "",
              },
              {
                id: 4,
                name: "回答4",
                value: "",
              },
            ],
            script: "",
            audio: null,
            isAnsewr: 1,
          },
        },
        answers: [
          {
            id: 1,
            name: "回答1",
            value: "",
          },
          {
            id: 2,
            name: "回答2",
            value: "",
          },
          {
            id: 3,
            name: "回答3",
            value: "",
          },
          {
            id: 4,
            name: "回答4",
            value: "",
          },
        ],
        answersConjugation: [
          {
            id: 1,
            value: "",
          },
          {
            id: 2,
            value: "",
          },
          {
            id: 3,
            value: "",
          },
          {
            id: 4,
            value: "",
          },
        ],
        wrongAnswersConjugation: [
          {
            id: 1,
            value: "",
          },
          {
            id: 2,
            value: "",
          },
          {
            id: 3,
            value: "",
          },
          {
            id: 4,
            value: "",
          },
        ],
      };
      this.$v.$reset();
      // this.$v.$touch();
    },
  },
  beforeDestroy() {
    this.formGeneral = {
      leadSentence: "",
      name1: "",
      name2: "",
      isAnsewr: 1,
      verb: "",
      kanji: "",
      audio: null,
      image: null,
      script: "",
      sub_question: {
        question1: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
        question2: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
      },
      answers: [
        {
          id: 1,
          name: "回答1",
          value: "",
        },
        {
          id: 2,
          name: "回答2",
          value: "",
        },
        {
          id: 3,
          name: "回答3",
          value: "",
        },
        {
          id: 4,
          name: "回答4",
          value: "",
        },
      ],
      answersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
      wrongAnswersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
    };
  },
};
</script>
<style>
.col-lable {
  min-width: 120px;
  max-width: 120px;
}
</style>
<style lang="scss" scoped>
#Audio {
  height: 40px;
  margin-top: 4px;
}
.template-show {
  border: 1px solid #ccc;
}
</style>